import React from "react";
import {t} from "../../../shared-services/translate";
import Certificates from "../Certificates";
import useWindowTools from "../../../react-hooks/useWindowTools";
import {
  GlutenFreeBadge,
  LactoseFreeBadge,
  SulphitesBadge,
  FarmyFamily, LocalBadge,
  SpecialOffer,
  Exclusive
} from "../Badges/Badges";
import DiscountBadge from "../Badges/DiscountBadge";
import {FarmyColumn, FarmyColumnSet} from "../../layouts/components/FarmyColumns";

const BadgesPDP = (props) => {
  const {product} = props;
  const {
    certificates = [],
    nutritional_tags: nutritionalTags = [],
    main_info_tags: mainInfoTags = []
  } = product;

  const {isMobile} = useWindowTools();

  return <div className="position-absolute full-width full-height">
    <div
      className={`
        position-absolute
        top-0 right-0
        certificates-wrapper
        padding-10
        flex
        flex-direction-column
        align-items-flex-end
      `}
      style={{height: "55px"}}>

      <DiscountBadge product={product} className="margin-bottom-5"/>

      {certificates.length > 0 && <Certificates
        certificates={certificates}
        layout={"pdp"}
        className="flex-direction-column gap-5"
      />}
    </div>

    <div className="position-absolute top-0 left-0 padding-10 margin-top-5">
      <FarmyColumnSet gap="10px">
        <FarmyColumn className="flex flex-direction-column gap-5">
          {mainInfoTags.length > 0 &&
            mainInfoTags.map(tag => {
              const InfoTag = infoBadges[tag];
              return InfoTag ? <InfoTag key={tag}/> : null;
            })
          }
        </FarmyColumn>

        <FarmyColumn className="flex flex-direction-column gap-5">
          {nutritionalTags.length > 0 && nutritionalTags.map(tag => {
            const NutritionalTag = nutritionalBadges[tag];
            return NutritionalTag ? <NutritionalTag key={tag}/> : null;
          })}
        </FarmyColumn>
      </FarmyColumnSet>
    </div>

    {product?.frozen_shipping &&
      <div
        className={`
          position-absolute
          margin-bottom-10
          margin-left-10
          bottom-0 left-0
        `}
        style={{
          width: isMobile ? "35px" : "42px"
        }}
      >
        <img
          className="product-frozen-shipping full-width"
          src={"/icons/icon-frozen-md.png"}
          alt={t("product.frozen_freshness")}/>
      </div>
    }
  </div>;
};

export default BadgesPDP;

const nutritionalBadges = {
  gluten_free: GlutenFreeBadge,
  lactose_free: LactoseFreeBadge,
  sulphites: SulphitesBadge
};

const infoBadges = {
  farmy_family: FarmyFamily,
  local: LocalBadge,
  special_offer: SpecialOffer,
  exclusive: Exclusive
};
